import {
  AcademicCapIcon,
  BeakerIcon,
  BuildingLibraryIcon,
  BuildingOfficeIcon,
  LightBulbIcon,
  PresentationChartLineIcon,
} from '@heroicons/react/24/outline';
import { DiscoverSubmissionTypes } from './DiscoverSubmissionTypes';

export enum ApiSubmissionKinds {
  academic = 'academic',
  biotechAsset = 'biotechAsset',
  centreOfExcellence = 'centreOfExcellence',
  researchProject = 'researchProject',
  spinout = 'spinout',
  technology = 'technology',
}

interface Opportunity {
  [key: number]: {
    assetName: string;
    labelPlural: string;
    labelSingular: string;
    description: string;
    apiSubmissionKind: ApiSubmissionKinds;
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  };
}

export const submissionTypeToSubmissionKind = {
  [DiscoverSubmissionTypes.externalTechnology]: ApiSubmissionKinds.technology,
  [DiscoverSubmissionTypes.technology]: ApiSubmissionKinds.technology,
  [DiscoverSubmissionTypes.academic]: ApiSubmissionKinds.academic,
  [DiscoverSubmissionTypes.centreOfExcellence]: ApiSubmissionKinds.centreOfExcellence,
  [DiscoverSubmissionTypes.researchProject]: ApiSubmissionKinds.researchProject,
  [DiscoverSubmissionTypes.spinout]: ApiSubmissionKinds.spinout,
  [DiscoverSubmissionTypes.biotechAsset]: ApiSubmissionKinds.biotechAsset,
} as const;

export const icoOpportunityTypes: Opportunity = {
  1: {
    assetName: 'technology',
    labelPlural: 'Technologies',
    labelSingular: 'Technology',
    description:
      'Tools, platforms, or innovations applied to enhance drug development, healthcare delivery, or operational efficiency.',
    apiSubmissionKind: ApiSubmissionKinds.technology,
    Icon: LightBulbIcon,
  },
  2: {
    assetName: 'academic-expertise',
    labelPlural: 'Academics and Expertise',
    labelSingular: 'Academic Researcher',
    description:
      'Detailed accounts of researchers’ educational backgrounds, scientific contributions, and institutional affiliations, showcasing their expertise and role.',
    apiSubmissionKind: ApiSubmissionKinds.academic,
    Icon: AcademicCapIcon,
  },
  3: {
    assetName: 'centre-of-excellence',
    labelPlural: 'Centres of Excellence',
    labelSingular: 'Centre of Excellence',
    description:
      'Specialized institutions or hubs with expertise in a specific area of biopharma research, development, or technology application.',
    apiSubmissionKind: ApiSubmissionKinds.centreOfExcellence,
    Icon: BuildingLibraryIcon,
  },
  4: {
    assetName: 'research-project',
    labelPlural: 'Research Projects',
    labelSingular: 'Research Project',
    description:
      'Specific scientific studies or initiatives aimed at exploring, validating, or advancing knowledge in areas like drug discovery, clinical trials, or disease mechanisms.',
    apiSubmissionKind: ApiSubmissionKinds.researchProject,
    Icon: PresentationChartLineIcon,
  },
  5: {
    assetName: 'spin-out',
    labelPlural: 'Company Profiles',
    labelSingular: 'Company Profile',
    description:
      'Independent businesses formed to commercialize technologies, research, or intellectual property developed within a larger organization, such as a university or biotech firm.',
    apiSubmissionKind: ApiSubmissionKinds.spinout,
    Icon: BuildingOfficeIcon,
  },
  6: {
    assetName: 'biotech-asset',
    labelPlural: 'Biotech Assets',
    labelSingular: 'Biotech Asset',
    description:
      'Tangible or intangible resources, such as drug candidates, intellectual property, or proprietary data.',
    apiSubmissionKind: ApiSubmissionKinds.biotechAsset,
    Icon: BeakerIcon,
  },
};
